import React, { useEffect, useState } from "react";
import "../../index.css";
import { useLocation } from "react-router-dom";
import Genie from "../../assets/earnings/genie-business.svg";

import PlayStore from "../../assets/navbar/playStore.svg";
import AppStore from "../../assets/navbar/appStore.svg";
import earn from "../../assets/earnings/earn.png";
import AppStoreModal from "../utils/AppStoreModal";
import earn_with_us from "../../assets/Home/earn_with_us.png";
import culturtap_genie_business_app from "../../assets/Home/culturtap_genie_business_app.png";

const Earn = () => {
  const location = useLocation();
  const [appStoreModal, setAppStoreModal] = useState(false);

  useEffect(() => {
    // console.log("location", location.search);
    if (location.search.includes("termandcondition")) {
      // console.log("location");
      window.scrollTo({
        top: 1300,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <div className="max-sm:px-[30px] max-lg:px-[50px] lg:ml-[120px] md:mt-[60px] max-sm:pt-[100px] overflow-x-hidden">
      <div className="w-full flex flex-col-reverse lg:flex-row mt-[20px] gap-1  md:mt-[100px]  ">
        <div className="lg:w-[50%] flex flex-col  ">
          <div className="w-full flex flex-col gap-6 mb-10 ">
            <img
              src={earn_with_us}
              alt="Earn with Us"
              className="w-[500px] max-w-full object-contain"
            />
            <img
              src={culturtap_genie_business_app}
              alt="CulturTap Genie Business"
              className="w-[400px] max-w-full object-contain"
            />
          </div>
          <div className="">
            <p className=" text-[14px] poppins-bold text-[#2F2E41] my-4">
            Power Up Sales, Reach More Customers, Close Deals Faster. 
            </p>
            <p className=" text-[14px] poppins-regular text-[#001B33]">
            The CulturTap Genie Business App is designed for small business owners - from local stores to maintenance professionals. Whether you're running a store, repairing things, or starting your own hustle, this app is your smart companion for tapping into local demand.
            <br /> <br />
            List your store or service across 45+ high-demand categories - including Fashion, Sari, Suit, Shoe, Bag, Electronics, Gifts, Jewel, Appliances, Watches, Sports, Utensils, Plumber, Electrician, and more.
              <br /> <br />
              Join the growing "Community of Local Vendors" supporting small businesses and independent professionals. CulturTap Genie brings everyone together into a local-first ecosystem where real-time bargaining connects you directly with nearby customers.
            </p>
            <p className=" text-[14px]    mt-6 poppins-bold text-[#001B33]">
                Engage Locally.Build Trust. Grow Rapidly.
                <br /> <br />
                Unlock Your Business Potential - Download the CulturTap Genie Business App and Transform Your Sales Now!
            </p>
          </div>
        </div>

        <div className="lg:w-[50%] flex justify-center">
          <div className="flex flex-1 justify-center mt-[30px] lg:mt-6">
            <img
              src={earn}
              alt="contact"
              loading="lazy"
              className="w-[250px] h-[300px] sm:w-[300px] sm:h-[320px] lg:w-[500px] lg:h-[593px]  "
            />
          </div>
        </div>
      </div>
      <div className="mt-10 md:mt-6 w-full flex-row justify-center items-center">
        <div className="flex max-sm:flex-col flex-row justify-center  items-center gap-[10px] border-[1px] w-max p-[20px] border-[#FB8C00]">
          <img
            src={Genie}
            alt="logo"
            loading="lazy"
            className=" w-[120px] h-[80px] xl:w-[102px] xl:h-[102px]"
          />
          <div className="flex flex-col gap-2">
            <p className=" text-[12px] md:text-[14px] xl:text-[14px] font-bold text-[#2E2C43] max-sm:text-center">
              Download the Business App
            </p>
            <div className="flex flex-row gap-[6px]">
              <button
                onClick={() => {
                  setAppStoreModal(!appStoreModal);
                }}
                className=" cursor-pointer"
              >
                <img
                  src={AppStore}
                  alt="logo"
                  loading="lazy"
                  width="120px"
                  height="44px"
                />
              </button>
              <a href="https://play.google.com/store/apps/details?id=com.culturtapgenieretailer.GenieApp" className="cursor-pointer ">
                <img
                  src={PlayStore}
                  alt="logo"
                  loading="lazy"
                  width="120px"
                  height="44px"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {appStoreModal && <AppStoreModal setAppStoreModal={setAppStoreModal} />}
    </div>
  );
};

export default Earn;
